import {CTA_ACTIONS, CTA_TYPES} from '../constants/constantEnums';
import Button from '../../stories/components/common/CTA/Type1';
import Link from '../../stories/components/common/Link/Link';
const handleClickCB = ({data, onClickCB, index}) => {
  Array.isArray(data?.action)
    ? onClickCB?.(data?.action[index]?.api)
    : onClickCB?.(data?.action?.api);
};

const handleOpenModel = ({data, openModal}) => {
  openModal?.(data?.action);
};

const handleCloseModal = ({data, closeModal}) => {
  closeModal?.(data?.action);
};

const handleExternalLink = ({data, index}) => {
  Array.isArray(data?.action)
    ? window.open(data?.action[index]?.href, '_blank')
    : window.open(data?.action?.href, '_blank');
};

const handleInternalLink = ({data, index}) => {
  Array.isArray(data?.action)
    ? window.open(data?.action[index]?.href, '_self')
    : window.open(data?.action?.href, '_self');
};

export const actionHandlers = {
  [CTA_ACTIONS.API_CALL]: ({data, onClickCB, index}) => handleClickCB({data, onClickCB, index}),
  [CTA_ACTIONS.CLOSE_MODAL]: ({closeModal, data, logToOmniture}) =>
    handleCloseModal({data, closeModal, logToOmniture}),
  [CTA_ACTIONS.OPEN_MODAL]: ({openModal, data, logToOmniture}) =>
    handleOpenModel({data, openModal, logToOmniture}),
  [CTA_ACTIONS.EXTERNAL_LINK]: ({data, logToOmniture, index}) =>
    handleExternalLink({data, logToOmniture, index}),
  [CTA_ACTIONS.INTERNAL_LINK]: ({data, logToOmniture, index}) =>
    handleInternalLink({data, logToOmniture, index}),
};

export const customCallback = ({data, callback, index}) => {
  Array.isArray(data?.action) ? callback?.(data?.action[index]) : callback?.(data?.action);
};

export const ctaRenderers = {
  [CTA_TYPES.BUTTON]: Button,
  [CTA_TYPES.LINK]: Link,
};
